import styled from "styled-components";

export const UpdateUserWrapper = styled.section`
  padding-top: 26px;
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: 80%;
    margin: 0 auto;
  }
`;

export const IconContainer = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
